import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {ResetPasswordView} from "./resetPasswordView";

export class ResetPasswordPresenter implements IPresenter{
 
    public _view: ResetPasswordView;

    constructor(resetPasswordView: ResetPasswordView) {
        this._view = resetPasswordView;
    }
    async initialize() {
    }
    
    async login(){
        alert('Hello ' + this._view.email);
    }

    inject() {
    }
    
}